import type { Document } from '@contentful/rich-text-types';

function filterPageBreakMacro(document: Document | undefined) {
  if (!document) return undefined;

  const filteredContent = document.content.filter((el) => {
    // @ts-expect-error - we know that not all of them have a value, that's ok
    if (el.content[0]?.value?.trim() === '#PAGEBREAK') return false;
    return true;
  });

  // Return a new document object instead of mutating the original
  return {
    ...document,
    content: filteredContent,
  };
}

export { filterPageBreakMacro };
